'use client'

import { Box, BoxProps } from '@chakra-ui/react'

type BorderProps = BoxProps

export const Border = ({ ...boxProps }: BorderProps) => (
  <Box {...boxProps} borderBottomColor="border" borderBottomStyle="solid" borderBottomWidth="1px" />
)
